var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"logo",attrs:{"href":"/"}},[_c('img',{attrs:{"src":require(("@/assets/img/" + _vm.pictureSrc)),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }